//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const redColorValue = ref(115)
    const greenColorValue = ref(103)
    const blueColorValue = ref(240)

    return { redColorValue, greenColorValue, blueColorValue }
  },
}
